import axios from 'axios';
import store from '@/store';
import qs from 'qs';
import { paramsFilter } from '@/utils';
import { Toast } from 'vant';
import 'vant/lib/index.css';

const loginUrl = process.env.VUE_APP_WORK_ORDER_URL_USERCENTER;
const commonUrl = process.env.VUE_APP_API;

// 请求拦截器
axios.interceptors.request.use(config => {
  config.headers['lang'] = localStorage.getItem('lang') || 'en_GB';
  if (store.state.user.token) {
    config.headers.Authorization = 'Bearer ' + store.state.user.token;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use(res => {
  const response = res.data;
  if (response.code === '200') {
    // 正常返回
    return response;
  } else if (response.code === '30' || response.code === '201' || response.code === '202') {
    // 无数据
    if (response.code === '202') {
      Toast({
        message: response.message || response.data
      });
    }
    return Promise.reject(response);
  } else if (response.code === '401') {
    store.commit('USER_SIGN_OUT');
    return Promise.reject(response);
  }
  Toast({
    message: response.message || response.data
  });
  return Promise.reject(response);
},
error => {
  var errorSponse = error.response;
  Toast({
    message: errorSponse.data.message
  });
  if (errorSponse.data.code === '203') {
    return Promise.reject(errorSponse.data);
  }
  return Promise.reject(error);
});

export function fetch (url, params, method, login) {
  axios.defaults.baseURL = login ? loginUrl : commonUrl;
  if (method === 'postJson') {
    axios.defaults.headers['Content-Type'] = 'application/json';
  } else if (method === 'put') {
    axios.defaults.headers['Content-Type'] = 'multipart/form-data';
  } else {
    axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  };
  if (url === '/user/v1/manager/sso/getRedirectUrl' || url === '/user/languageCode/open/saveLocale') {
    axios.defaults.withCredentials = true;
  };
  return new Promise((resolve, reject) => {
    if (method === 'post') {
      axios.post(url, qs.stringify(params))
        .then(response => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    } else if (method === 'postJson') {
      axios.post(url, params)
        .then(response => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    } else if (method === 'put') {
      axios.post(url, params)
        .then(response => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    } else if (method === 'get') {
      axios.get(url, { params })
        .then(response => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    } else if (method === 'delete') {
      axios.delete(url, params)
        .then(response => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    };
  });
};

export default {
  // post方法
  postMockdata (url, params, login = '') {
    let temp = params;
    if (params) {
      temp = JSON.stringify(params);
      temp = JSON.parse(temp);
    };
    return fetch(url, paramsFilter(temp), 'post', login);
  },
  // postJSON方法
  jsonPostMockdata (url, params, login = '') {
    let temp = params;
    if (params) {
      temp = JSON.stringify(params);
      temp = JSON.parse(temp);
    };
    return fetch(url, temp, 'postJson', login);
  },
  // get方法
  getMockdata (url, params, login = '') {
    let temp = params;
    if (params) {
      temp = JSON.stringify(params);
      temp = JSON.parse(temp);
    };
    return fetch(url, paramsFilter(temp), 'get', login);
  },
  // delete方法
  deleteMockdata (url, params, login = '') {
    let temp = params;
    if (params) {
      temp = JSON.stringify(params);
      temp = JSON.parse(temp);
    };
    return fetch(url, temp, 'delete', login);
  },
  // put方法
  putMockdata (url, params, login = '') {
    return fetch(url, params, 'put', login);
  }
};
